import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = graphql.transformers.IN.nonNull(
  graphql.transformers.IN.object<
    ents.core.relay.Command,
    graphql.schema.RelayCommandInput
  >({
    operation: transformers.PASS_THROUGH,
    payload: transformers.PASS_THROUGH,
  }),
)

export const LIST_TRANSFORMER = graphql.transformers.IN.default(
  graphql.transformers.IN.list(TRANSFORMER, {
    onNullish: 'remove',
  }),
  [],
)
